(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nah-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-nah-contact]').forEach(function (el) {
        if (el.__nahContactInit) return;
        el.__nahContactInit = true;

        var form = el.querySelector('form');
        if (!form) return;
        var select = form.querySelector('[data-nah-reason]');
        var msg = form.querySelector('[data-nah-msg]');
        var btn = form.querySelector('[data-nah-submit]');

        function show(text, ok) {
          msg.textContent = text;
          msg.hidden = false;
          msg.className = 'nah-contact__msg' + (ok ? ' nah-contact__msg--ok' : ' nah-contact__msg--error');
        }

        form.addEventListener('submit', function (e) {
          var opt = select && select.options[select.selectedIndex];
          var endpoint = opt && opt.getAttribute('data-endpoint');
          if (!endpoint) return; // no endpoint for this reason: normal Shopify submit

          e.preventDefault();
          if (form.querySelector('[data-nah-hp]').value) { show(msg.getAttribute('data-ok'), true); return; }

          var reason = opt.value;
          var name = form.querySelector('[data-nah-name]').value;
          var email = form.querySelector('[data-nah-email]').value;
          var message = form.querySelector('[data-nah-message]').value;

          var data = new FormData();
          data.append('name', name);
          data.append('email', email);
          data.append('reason', reason);
          data.append('message', message);
          data.append('_subject', '[' + reason + '] New message from ' + name);

          btn.disabled = true;
          fetch(endpoint, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
            .then(function (r) {
              if (!r.ok) throw new Error('bad response');
              form.reset();
              show(msg.getAttribute('data-ok'), true);
            })
            .catch(function () { show(msg.getAttribute('data-error'), false); })
            .then(function () { btn.disabled = false; });
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nah-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nahFooterLangInit) return;
    window.__nahFooterLangInit = true;
    document.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('[data-nah-lang-select]') : null;
      if (sel && sel.form) sel.form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nah-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nahHeaderInit) return;
    window.__nahHeaderInit = true;

    /* ---- Mobile menu toggle (delegated, survives editor re-renders) ---- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nah-menu-toggle]');
      if (!btn) return;
      var header = btn.closest('.nah-header');
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.nah-header.is-open').forEach(function (h) {
        h.classList.remove('is-open');
        var b = h.querySelector('[data-nah-menu-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });

    /* ---- Cart icon: open the Horizon cart drawer (falls back to the cart page link) ---- */
    // Horizon markup: <theme-drawer id="cart-drawer"> > <dialog> > <cart-drawer-component auto-open>
    // open() lives on the <theme-drawer>, not on <cart-drawer-component>.
    function findDrawer() {
      return document.querySelector('theme-drawer#cart-drawer')
        || document.getElementById('cart-drawer')
        || document.querySelector('cart-drawer-component');
    }
    // Returns false only if there is no drawer or nothing could be triggered.
    function openDrawer() {
      var drawer = findDrawer();
      if (!drawer) {
        console.warn('[NAH] No Horizon cart drawer found on this page (looked for <theme-drawer id="cart-drawer">).');
        return false;
      }
      var dlg = drawer.matches('dialog') ? drawer : (drawer.querySelector('dialog') || (drawer.closest && drawer.closest('dialog')));
      if (dlg && dlg.open) return true;                        // already open
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
      if (dlg && typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch (e) {} return true; }
      if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function') {
        Shopify.actions.openCart();
        return true;
      }
      console.warn('[NAH] Found the cart drawer element but could not open it.', drawer);
      return false;
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-nah-cart-link]');
      if (!link || link.getAttribute('data-cart-action') !== 'drawer') return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (!openDrawer()) return;                 // no drawer on the page: just follow the link
      e.preventDefault();
      var header = link.closest('.nah-header');   // close the mobile menu if it was open
      if (header && header.classList.contains('is-open')) {
        header.classList.remove('is-open');
        var t = header.querySelector('[data-nah-menu-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });

    /* ---- "#cart" links anywhere (footer menu, buttons, etc.): open the cart drawer ---- */
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.hash !== '#cart') return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // a link to "#cart" on a different page just loads that page, then opens the drawer (see below)
      if (a.origin !== window.location.origin || a.pathname !== window.location.pathname) return;
      e.preventDefault();
      if (!openDrawer()) window.location.href = cartRoot + 'cart';
    });
    function openFromHash() {
      if (window.location.hash !== '#cart') return;
      setTimeout(function () {
        if (window.history && history.replaceState) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        if (!openDrawer()) window.location.href = cartRoot + 'cart';
      }, 300);
    }
    if (document.readyState === 'complete') { openFromHash(); } else { window.addEventListener('load', openFromHash); }

    /* ---- Live cart count ---- */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function refreshCount() {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-nah-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    ['cart:update', 'cart:change', 'cart:refresh', 'cart:updated', 'cart:item-added', 'product:added']
      .forEach(function (name) { document.addEventListener(name, refreshCount); });

    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var input = arguments[0];
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(refreshCount, 60); });
        }
      } catch (err) {}
      return p;
    };

    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nah-media-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function startVideos(root) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      (root || document).querySelectorAll('.nah-grid__video').forEach(function (v) {
        v.muted = true;
        v.setAttribute('playsinline', '');
        if (reduce) { v.pause(); return; }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    startVideos();
    document.addEventListener('shopify:section:load', function (e) { startVideos(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nah-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---- Horizon cart drawer helpers ---- */
    // Horizon markup: <theme-drawer id="cart-drawer"> > <dialog> > <cart-drawer-component auto-open>
    // open() lives on the <theme-drawer>, not on <cart-drawer-component>.
    function findDrawer() {
      return document.querySelector('theme-drawer#cart-drawer')
        || document.getElementById('cart-drawer')
        || document.querySelector('cart-drawer-component');
    }
    // Returns false only if there is no drawer or nothing could be triggered.
    function openDrawer() {
      var drawer = findDrawer();
      if (!drawer) {
        console.warn('[NAH] No Horizon cart drawer found on this page (looked for <theme-drawer id="cart-drawer">).');
        return false;
      }
      var dlg = drawer.matches('dialog') ? drawer : (drawer.querySelector('dialog') || (drawer.closest && drawer.closest('dialog')));
      if (dlg && dlg.open) return true;                        // already open
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
      if (dlg && typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch (e) {} return true; }
      if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function') {
        Shopify.actions.openCart();
        return true;
      }
      console.warn('[NAH] Found the cart drawer element but could not open it.', drawer);
      return false;
    }
    // Horizon's cart components listen for "cart:update" and refresh the drawer contents
    function notifyCart(qty) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: qty, source: 'product-form-component' } }
      }));
    }

    function init(root) {
      root.querySelectorAll('[data-nah-pdp]').forEach(function (el) {
        if (el.__nahPdpInit) return;
        el.__nahPdpInit = true;

        var form = el.querySelector('form');
        if (!form) return;
        var dataEl = el.querySelector('[data-nah-variants]');
        var variants = [];
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

        var idInput = el.querySelector('[data-nah-variant-id]');
        var btn = el.querySelector('[data-nah-atc]');
        var label = el.querySelector('[data-nah-atc-label]');
        var price = el.querySelector('[data-nah-atc-price]');
        var errorEl = el.querySelector('[data-nah-error]');
        var selects = el.querySelectorAll('[data-nah-option]');
        var showPrice = el.dataset.showPrice === 'true';
        var restoreTimer;

        function currentValues() {
          return Array.prototype.map.call(selects, function (s) { return s.value; });
        }
        function findVariant() {
          var vals = currentValues();
          for (var i = 0; i < variants.length; i++) {
            var ok = true;
            for (var j = 0; j < vals.length; j++) { if (variants[i].options[j] !== vals[j]) { ok = false; break; } }
            if (ok) return variants[i];
          }
          return null;
        }
        function render(v) {
          errorEl.hidden = true;
          if (!v) {
            btn.disabled = true;
            label.textContent = el.dataset.unavailableLabel;
            if (price) price.textContent = '';
            return;
          }
          idInput.value = v.id;
          btn.disabled = !v.available;
          label.textContent = v.available ? el.dataset.addLabel : el.dataset.soldLabel;
          if (price) price.textContent = (v.available && showPrice) ? v.price : '';
        }

        if (selects.length) {
          selects.forEach(function (s) {
            s.addEventListener('change', function () {
              var v = findVariant();
              render(v);
              if (v && window.history && history.replaceState) {
                var url = new URL(window.location.href);
                url.searchParams.set('variant', v.id);
                history.replaceState(null, '', url.toString());
              }
            });
          });
        }

        /* "drawer" and "stay" modes: add with the Cart API, no page navigation */
        if (el.dataset.behavior === 'drawer' || el.dataset.behavior === 'stay') {
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            btn.disabled = true;
            errorEl.hidden = true;
            fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
              .then(function (res) {
                if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || 'error');

                if (el.dataset.behavior === 'drawer') {
                  notifyCart(1);
                  setTimeout(function () {
                    if (!findDrawer()) { window.location.href = root + 'cart'; return; }   // cart type is "page": no drawer exists
                    // Horizon's <cart-drawer-component auto-open> opens the drawer itself when it hears the cart update
                    var comp = document.querySelector('cart-drawer-component');
                    if (!(comp && comp.hasAttribute('auto-open'))) openDrawer();
                  }, 150);
                  var v0 = selects.length ? findVariant() : null;
                  if (v0) { render(v0); } else { btn.disabled = false; }
                  return;
                }

                label.textContent = el.dataset.addedLabel;
                clearTimeout(restoreTimer);
                restoreTimer = setTimeout(function () {
                  var v = selects.length ? findVariant() : null;
                  if (v) { render(v); } else { label.textContent = el.dataset.addLabel; btn.disabled = false; }
                }, 1800);
              })
              .catch(function (err) {
                errorEl.textContent = err.message === 'error' ? 'Could not add to cart. Please try again.' : err.message;
                errorEl.hidden = false;
                btn.disabled = false;
              });
          });
        }
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nah-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      var url = el.getAttribute('data-url');
      if (!url || el.__nahRelLoading) return;
      el.__nahRelLoading = true;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('[data-nah-rel]');
          if (src && src.querySelector('[data-nah-rel-items]')) {
            el.innerHTML = src.innerHTML;
          }
          el.removeAttribute('data-url');
        })
        .catch(function () {});
    }
    function init(root) {
      root.querySelectorAll('[data-nah-rel][data-url]').forEach(load);
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nah-worn-by"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-nah-worn]').forEach(function (el) {
        if (el.__nahWornInit) return;
        el.__nahWornInit = true;

        var carousel = el.querySelector('[data-nah-carousel]');
        var track = el.querySelector('[data-nah-track]');
        var prev = el.querySelector('[data-nah-prev]');
        var next = el.querySelector('[data-nah-next]');
        if (!carousel || !track || !prev || !next) return;

        function update() {
          var max = track.scrollWidth - track.clientWidth;
          var scrollable = max > 2;
          prev.hidden = !scrollable;
          next.hidden = !scrollable;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;

          var media = track.querySelector('.nah-worn__media');
          if (media) carousel.style.setProperty('--nah-w-media-h', media.offsetHeight + 'px');
        }

        function step(dir) {
          var slide = track.querySelector('.nah-worn__slide');
          if (!slide) return;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: dir * (slide.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        prev.addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        track.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', update, { once: true });
        });
        update();
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
